"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";
import { loadGrowthbookFeatures, getFeatureValue } from "@utils/growthBook";

const ACKODRIVE_OMS_QUOTE = "ackodrive20_oms";
const ACKODRIVE_PRICING = "ackodrive-20-pricing";

interface MMVRedirectCheckProps {
  slug: string;
  userId?: string;
}

export default function MMVRedirectCheck({
  slug,
  userId,
}: MMVRedirectCheckProps) {
  const searchParams = useSearchParams();
  
  useEffect(() => {
    if (!userId) return;
    
    const checkAndRedirect = async () => {
      try {
        await loadGrowthbookFeatures(userId);

        const showNewQuoteFlow = getFeatureValue({
          flagName: ACKODRIVE_PRICING,
        });

        if (showNewQuoteFlow) {
          const queryString = searchParams?.toString() || "";
          const redirectUrl = queryString
            ? `/cars/v2/${slug}?${queryString}`
            : `/cars/v2/${slug}`;

          window.location.href = redirectUrl;
        }
      } catch (error) {
        console.error("Error checking feature flag:", error);
      }
    };

    checkAndRedirect();
  }, []);

  return null;
}
